module.exports = __webpack_public_path__ + "media/vip.e86b7276.mp4";